import { adaptDataForSubmission } from "@/core/helpers/assessment-submission-adapter";
import { api } from "@/api";
import type { AssessmentSubmissionParams, AssessmentSubmissionResponse } from "@/core/types";

export async function postAnswer({
  assessmentDefinitionId,
  assessmentDefinitionVersion,
  formData,
  taskId,
}: AssessmentSubmissionParams): Promise<AssessmentSubmissionResponse> {
  const submissionBody = adaptDataForSubmission({
    assessmentDefinitionId,
    assessmentDefinitionVersion,
    formData,
    taskId,
  });

  return api.assessmentTyped.post_answer({
    data: submissionBody,
    params: { showLoader: false },
  });
}
